import { __rest } from '../node_modules/tslib/tslib.es6.mjs.js';
import React__default, { useState, useRef } from 'react';
import { isNextJS } from '../utils.js';
import { Link } from 'react-router-dom';
import { useIsomorphicLayoutEffect } from '@breville/xps-utils/core/useIsomorphicLayoutEffect';

const isNext = isNextJS();
// https://nextjs.org/docs/pages/api-reference/components/link#if-the-child-is-a-custom-component-that-wraps-an-a-tag
const NextButton = React__default.forwardRef((props, ref) => {
    const { children, showChildren } = props, rest = __rest(props, ["children", "showChildren"]);
    return (React__default.createElement("a", Object.assign({}, rest, { ref: ref }), showChildren ? children : React__default.createElement("span", null)));
});
// LINK ADAPTER
// dynamically use next/link component or fallback to standard anchor tag
const LinkAdapter = (props) => {
    const { href: to, children } = props, restProps = __rest(props, ["href", "children"]);
    const [showChildren, setShowChildren] = useState(false);
    const ref = useRef(null);
    // Avoid hydration error
    useIsomorphicLayoutEffect(() => {
        setShowChildren(true);
    }, []);
    const isDocumentType = to ? /\.(pdf)$/i.test(to) : false;
    const isNextUrlPattern = to ? /[a-z]{2}-[a-z]{2}/.test(to) : false;
    if (!props.href)
        return React__default.createElement(React__default.Fragment, null);
    if (isDocumentType) {
        return React__default.createElement("a", { href: to, target: '_blank', rel: 'noopener noreferrer' }, children);
    }
    if (isNext && !isNextUrlPattern) {
        return React__default.createElement("a", Object.assign({ href: to }, restProps), children);
    }
    if (isNext) {
        try {
            const NextLink = require.resolve('next/link').default;
            return (React__default.createElement(NextLink, { href: to, passHref: true, legacyBehavior: true },
                React__default.createElement(NextButton, Object.assign({}, props, { showChildren: showChildren, ref: ref }))));
        }
        catch (_a) {
            return React__default.createElement('a', props);
        }
    }
    else {
        try {
            return React__default.createElement(Link, Object.assign({ to: to }, restProps), children);
        }
        catch (error) {
            return React__default.createElement('a', props);
        }
    }
};
LinkAdapter._isNextComponent = isNext;

export { LinkAdapter as default };
//# sourceMappingURL=Link.js.map
